import { ToggleSideMenuCollapsed } from './actionTypes';
import { TOGGLE_SIDE_MENU_COLLAPSED } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const toggleSideMenuCollapsed = (): ToggleSideMenuCollapsed => ({
  type: TOGGLE_SIDE_MENU_COLLAPSED,
});
